import * as S from '@blisspointmedia/bpm-types/dist/StreamingPerformance';
import { awaitJSON, pollS3, StreamingPerformanceLambdaFetch } from '@src/utils/fetch-utils';
import { SetError } from '@src/redux/modals';

export const HIDE_MATCHED_RESPONSES_ALERT_KEY = 'matchedResponses_hideAlert';

export interface DownloadMatchedResponsesArgs {
  kpi: string;
  start?: string;
  end?: string;
  impsBetween: boolean;
  prefix: S.Prefix;
  isGraph: boolean;
  agency?: string;
  overloadFilenameKpi?: string;
  setStatus?: (status: '' | 'Requesting' | 'Generating') => void;
  setError: SetError;
}

export const downloadMatchedResponses = async (
  args: DownloadMatchedResponsesArgs
): Promise<void> => {
  const {
    kpi,
    start = '',
    end = '',
    impsBetween,
    prefix,
    isGraph,
    agency = 'bpm',
    overloadFilenameKpi,
    setStatus,
    setError
  } = args;

  try {
    setStatus?.('Requesting');
    const res = await StreamingPerformanceLambdaFetch<S.GetMatchedResponsesParams>(
      '/matched_responses',
      {
        params: {
          kpi,
          start,
          end,
          impsBetween,
          prefix,
          agency,
          isGraph
        }
      }
    );
    const { id, bucket, ext } = await awaitJSON<S.GetMatchedResponsesResponse>(res);
    setStatus?.('Generating');
    await pollS3({
      bucket,
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ext,
      filename: id,
      autoDownload: true,
      overloadFilename: `matched_responses_${overloadFilenameKpi ?? kpi}.xlsx`,
      withErrors: true,
      noTimeout: true
    });
  } catch (e) {
    setError({
      reportError: e,
      message: e instanceof Error ? e.message : String(e)
    });
  }
  setStatus?.('');
};
